module.exports = __webpack_public_path__ + "static/media/DetailsRow.fb5b0b69.css";


//////////////////
// WEBPACK FOOTER
// ./node_modules/wt-react/dist/components/StandardPerformance/DetailsRow.css
// module id = 1152
// module chunks = 0